



















import { defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails, TipStatisticItem, TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";
import TippedUsersList from "./components/TippedUsersList.vue";

export default defineComponent({
  name: "StreamTipsController",
  components: { BaseSpinner, TippedUsersList, BaseIcon },
  props: {
    sessionId: { type: String, default: "" },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const showList = ref(false);
    const loading = ref(false);
    const tipStatItems = ref<TipStatisticItem[]>([]);
    const totalAmount = ref(0);

    const getData = async () => {
      try {
        loading.value = true;
        const resp = await providers.TipProvider.statisticSearch({
          data: {
            subject: {
              subjectId: props.sessionId,
              subjectType: TipSubjectType.LIVE,
            },
          },
        });
        totalAmount.value = resp.totalAmount;
        tipStatItems.value = resp.items;
      } finally {
        loading.value = false;
      }
    };

    const handleShowList = async () => {
      showList.value = true;
      await getData();
    };

    const handleAddTip = (message?: Message) => {
      if (
        message &&
        message.senderId === "0" &&
        message.details &&
        isTipMessageDetails(message.details) &&
        "" + message.details.recipientId === authUser.value?.id
      ) {
        totalAmount.value += message.details.amount;
      }
    };
    getData();

    onMounted(() => {
      emitter.on<Message>(EVENTS.STREAM_TIP, handleAddTip);
    });

    onUnmounted(() => {
      emitter.off<Message>(EVENTS.STREAM_TIP, handleAddTip);
    });
    return {
      loading,
      tipStatItems,
      totalAmount,
      showList,
      handleShowList,
    };
  },
});
